import { updateUserEngagementTracking } from '../utils/ad-ops/updateUserEngagementTracking'
import { localStorage } from '../utils/storage'
import { USER_TRACKING_STORAGE_KEY } from '../store/userData/UserEngagementStore'

export default defineNuxtPlugin({
  name: 'user-segment',
  setup: async () => {
    const store = userEngagementStore()

    const syncState = () => {
      if (!store.isEnabled) return

      const { isEngaged, lastEngagementDate, lastEngagementAction } =
        store.$state
      localStorage.setItem(
        USER_TRACKING_STORAGE_KEY,
        JSON.stringify({
          isEngaged,
          lastEngagementDate,
          lastEngagementAction,
        })
      )
      updateUserEngagementTracking({
        isEngaged: store.isEngaged,
        lastEngagementDate: store.lastEngagementDate,
        lastEngagementAction: store.lastEngagementAction,
        daysSinceInstall: store.daysSinceInstall,
        daysSinceLastEngagement: store.daysSinceLastEngagement,
        installDate: store.installDate,
      })
    }

    await store.loadUserEngagement()
    syncState()
    store.$subscribe(syncState, { flush: 'sync' })
  },
})
